import { render, staticRenderFns } from "./AuthDescriptions.vue?vue&type=template&id=05474197&scoped=true&"
import script from "./AuthDescriptions.vue?vue&type=script&lang=js&"
export * from "./AuthDescriptions.vue?vue&type=script&lang=js&"
import style0 from "./AuthDescriptions.vue?vue&type=style&index=0&id=05474197&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05474197",
  null
  
)

export default component.exports